import { Record, Union } from "../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, union_type, float64_type } from "../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";

export class Progress_ProgressTracking extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Indeterminate", "Percentage"];
    }
}

export function Progress_ProgressTracking_$reflection() {
    return union_type("Client.JsInteropGeneral.Progress.ProgressTracking", [], Progress_ProgressTracking, () => [[], [["Item", float64_type]]]);
}

export class Progress_ProgressStatus$1 extends Record {
    constructor(stage, tracking) {
        super();
        this.stage = stage;
        this.tracking = tracking;
    }
}

export function Progress_ProgressStatus$1_$reflection(gen0) {
    return record_type("Client.JsInteropGeneral.Progress.ProgressStatus`1", [gen0], Progress_ProgressStatus$1, () => [["stage", gen0], ["tracking", Progress_ProgressTracking_$reflection()]]);
}

export function Cmd_ofCallbackPromise(task, arg, callback, ofSuccess, ofError) {
    return singleton((dispatch) => {
        task(arg, callback(dispatch)).then((arg_3) => {
            dispatch(ofSuccess(arg_3));
        }).catch((arg_2) => {
            dispatch(ofError(arg_2));
        });
    });
}

